<template>
  <div class="row m-0" v-if="can_access('deal','view')">
    <div class="col-sm-12 p-0 mb-2" v-if="can_access('deal','modify')">
      <select name="type" class="form-control col-sm-2 pull-right" v-model="capacity">
        <option selected value="AOTC,MTCH,DEAL,GIVEIN">All Capacity</option>
        <option value="AOTC">AOTC</option>
        <option value="MTCH">MTCH</option>
        <option value="DEAL">DEAL</option>
        <option value="GIVEIN">GIVEIN</option>
      </select>
    </div>
    <TableView :col="columns" :getData="getData" v-if="showTable"/>          
  </div> 
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date'],
  data(){
  	return {
      capacity: 'AOTC,MTCH,DEAL,GIVEIN',
      showTable: true,
      columns: (() => {
        const cols = [
          { title: 'CN', field: 'contract_note', thComp: 'FilterTh', tdStyle: {'text-decoration':'underline dashed'},sortable: true, tdOnClick:this.ShowDealDetail},
          { title: 'TN', field: 'ticket_number', thComp: 'FilterTh' },
          { title: 'Client Acc No', field: 'account_number', thComp: 'FilterTh', tdStyle: {padding: this.can_access('deal','modify')?"":"0.8rem !important"}},
          { title: 'Client Name', field: 'client_name', thComp: 'FilterTh'},
          { title: 'TD', field: 'trade_date', sortable: true },
          { title: 'SD', field: 'settlement_date', sortable: true },
          { title: 'T+', field: 'trade_plus', field_prefix: 'T+', thComp: 'FilterTh'},
          { title: 'ISIN', field: 'stock', nested: 'isin'},
          { title: 'Trade time', field: 'trade_time', sortable: true },
          { title: 'Buy/Sell', field: 'type', thComp: 'FilterTh', sortable: true, tdStyle: (row) => {if(["BUY","DEPOSIT","DIVIDENDS","FOP IN","TRANSFER IN","FX"].indexOf(row.type)>=0) return {color: "green"};else if(["SELL","WITHDRAWAL","TRANSFER OUT","FOP OUT"].indexOf(row.type)>=0) return {color: 'red'};}},
          { title: 'Counterparty Name', field: 'counterparty_name'},
          { title: 'Counterparty Broker Code', field: 'counterparty_broker_code'},
          { title: 'Stock', field: 'stock', nested: 'issuer_name', thComp: 'FilterTh'},
          { title: 'Ticker', field: 'stock', nested: 'tidm', thComp: 'FilterTh'},
          { title: 'Quantity', field: 'total_quantity', thComp: 'FilterTh', tdComp: 'Number', 'floatLength': 2},
          { title: 'Price', field: 'trade_price', sortable: true , tdComp: 'Number'},
          { title: 'Net settlement', field: 'trade_value', sortable: true, tdComp: 'Number'},
          { title: 'Currency', field: 'currency', thComp: 'FilterTh'},
          { title: 'Capacity', field: 'capacity', thComp: 'FilterTh'},
          /* { title: 'Cost Price', field: 'cost_price', tdComp: 'Number' },
          { title: 'Total Charges', field: 'total_other_charges', tdComp: 'Number' },
          { title: 'Cosideration', field: 'total_consideration', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Notes', field: 'notes', thComp: 'FilterTh'}, */
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  watch: {
    capacity: function(newValue){
      this.showTable = false;
      this.$nextTick(()=>{
        this.showTable = true;
      });
    }
  },
  created() {
  },
  methods: {
    async getData(query, filter) {
      var { limit = 100, offset = 0, sort = 'trade_date', order = '' } = JSON.parse(JSON.stringify(query));
      if(!sort) sort = 'trade_date';
      //filter['has_trade'] = 1;
      filter['approved_at'] = {from_date:'2000-01-01'};
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      });
      filter['trade_date'] = {from_date: this.report_date[0], to_date: this.report_date[1]};
      filter['capacity'] = this.capacity;
      //filter['type'] = "BUY,SELL";
      let uri = 'trade_list?with_cancelled=1&noGrouping=1&limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      this.$emit('setFilter', filter);
      return await this.call_axios(uri);
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>